import { get } from './httpRequest';

// eslint-disable-next-line import/prefer-default-export
export const fetchDeliveryStatements = async () => {
  const response = await get('/delivery-statements');
  return response.data;
};
